import { useState } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaMinus } from "react-icons/fa";

const menuData = [
  {
    title: "Trang chủ",
    path: "/",
  },
  {
    title: "Về chúng tôi",
    path: "/gioi-thieu",
  },
  {
    title: "Dịch vụ",
    path: "/dich-vu",
  },
  {
    title: "Dự án",
    path: "/du-an",
  },
  {
    title: "Blogs",
    path: "/bai-viet",
  },
  {
    title: "Thông tin",
    path: "#",
    children: [
      { title: "Thành viên", path: "/doi-ngu" },
      { title: "Câu hỏi thường gặp", path: "/cau-hoi-thuong-gap" },
      { title: "Liên hệ", path: "/lien-he" },
    ],
  },
  {
    title: "Liên kết",
    path: "#",
    children: [
      { title: "Website - App", path: "https://webapp24h.vn/" },
      { title: "Học viện Design24", path: "https://design24.edu.vn/" },
    ],
  },
];

// Kiểm tra đường dẫn có phải là liên kết ngoài hay không
const isExternalLink = (url) => /^(https?:\/\/)/.test(url);

const MobileMenuItem = ({ item }) => {
  const [open, setOpen] = useState(false);

  const renderLink = (title, path) => {
    if (isExternalLink(path)) {
      return (
        <a
          href={path}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </a>
      );
    }
    return <Link to={path}>{title}</Link>;
  };

  return (
    <li>
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => item.children && setOpen(!open)}
        style={{ cursor: item.children ? "pointer" : "default" }}
      >
        {renderLink(item.title, item.path)}
        {item.children && <span>{open ? <FaMinus /> : <FaPlus />}</span>}
      </div>
      {item.children && open && (
        <ul className="sub-menu">
          {item.children.map((child) => (
            <li key={child.title}>{renderLink(child.title, child.path)}</li>
          ))}
        </ul>
      )}
    </li>
  );
};

const MobileMenu = () => (
  <div className="mobile-menu fix mb-3">
    <ul>
      {menuData.map((item) => (
        <MobileMenuItem
          key={item.title}
          item={item}
        />
      ))}
    </ul>
  </div>
);

export default MobileMenu;
